import { useEffect, useState } from 'react'

import { useMediaQuery, useLpControl } from '@itau-loans-www/hooks'
import { sdkAnalytics } from '@itau-loans-www/services'
import { isOrganic, getIsAdsSourceURL } from '@itau-loans-www/utils'

import { text } from './content'

const useFGTSLp = (partnerName) => {
  const canonical = isOrganic
    ? 'https://www.itau.com.br/emprestimos-financiamentos/saque-aniversario-fgts'
    : 'https://emprestimo.itau.com.br/saque-aniversario-fgts'

  const isDesktop = useMediaQuery('desktop')

  const { openWppModal, setOpenWppModal } = useLpControl()

  const heroCustomClass =
    partnerName === 'magalu' || !partnerName ? '--fgts' : ''

  const lpText = text[partnerName ? 'partner' : 'default']

  const [isAdsSourceURL, setIsAdsSourceURL] = useState(false)

  useEffect(() => {
    const isAdsSourceURLState = getIsAdsSourceURL()
    setIsAdsSourceURL(isAdsSourceURLState)
    sdkAnalytics.track('trackEvent', {
      event_name: 'entrance',
      parameters: {
        custom_path: '/fgts/saque-aniversario/home',
        detail: 'tela-inicial-fgts-antercipacao-saque-aniversario'
      }
    })
  }, [])

  return {
    lpText,
    canonical,
    isAdsSourceURL,
    heroCustomClass,
    setOpenWppModal,
    isToShowModal: isDesktop && openWppModal
  }
}

export default useFGTSLp
